module.exports = __webpack_public_path__ + "img/SAS_Sword Ver2.0c2fe05c.png";